import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/Login.vue'
import Home from '../components/Home.vue'
import Welcome from '../components/Welcome.vue'
import Schedule from '../components/datadisplay/Schedule.vue'
import Delivery from '../components/datadisplay/Delivery.vue'
import Moq from '../components/datadisplay/Moq.vue'
import Readygoods from '../components/datadisplay/Readygoods.vue'
import RfqForwarder from '../components/datadisplay/RfqForwarder.vue'
import Project from '../components/datadisplay/Project.vue'
import Timeline from '../components/timeline/TimelineList.vue'
import ProspectProject from '../components/prospect/ProspectProject.vue'
import ProspectTimeline from '../components/prospect/ProspectTimelineList.vue'
import ProspectCRProject from '../components/prospect/ProspectCRProject.vue'
import ProspectCRTask from '../components/prospect/ProspectCRTask.vue'
import InitQuotation from '../components/quotation/InitQuote.vue'
import Pdr from '../components/pdr/PdrList.vue'
import ForwarderSchedule from '../components/supplierschedule/ForwarderSchedule.vue'
import ForwarderSchedule4IPIT from '../components/supplierschedule/ForwarderSchedule4IPIT.vue'
import Yach1Schedule from '../components/supplierschedule/Yach1Schedule.vue'
import YachPOSchedule from '../components/supplierschedule/YachPOSchedule.vue'
import InputSchedule from '../components/supplierschedule/InputSchedule.vue'
import ExportSchedule from '../components/supplierschedule/ExportSchedule.vue'
import CRProject from '../components/customerrelation/CRProject.vue'
import CRTask from '../components/customerrelation/CRTask.vue'
import Yach from '../components/datadisplay/Yach.vue'
import Yach4Customer from '../components/datadisplay/Yach4Customer.vue'
import YachHistory from '../components/datadisplay/YachHistory.vue'
import YachUpdatesHistory from '../components/datadisplay/YachUpdatesHistory.vue'
import RglFile from '../components/datadisplay/RglFile.vue'
import RglFileManage from '../components/datadisplay/RglFileManage.vue'
import ForwarderQtySchedule from '../components/supplierschedule/ForwarderQtySchedule.vue'
import Yach1CBMSchedule from '../components/supplierschedule/Yach1CBMSchedule.vue'
import Customer from '../components/customerbrand/Customer.vue'
import Brand from '../components/customerbrand/Brand.vue'
import CustomerContact from '../components/customerbrand/CustomerContact.vue'
import UserManagement from '../components/systemManagement/UserManagement.vue'
import QCReport from '../components/quality/QCReport.vue'
import QCSchedule from '../components/quality/QCSchedule.vue'
import Supplier from '../components/customerbrand/Supplier.vue'
import SupplierQC from '../components/customerbrand/SupplierQC.vue'
import SystemRole from '../components/customerbrand/SystemRole.vue'
import FollowUp from '../components/production/FollowUp.vue'
import Output from '../components/production/Output.vue'
import Factory from '../components/factory/Factory.vue'
import Machine from '../components/factory/Machine.vue'
import OutputCalendar from '../components/factory/OutputCalendar.vue'
import SubItem from '../components/factory/SubItem.vue'
import QARequest from '../components/quality/QARequest.vue'
import QATestRequest from '../components/quality/QATestRequest.vue'
import PublicTest from '../components/quality/PublicTest.vue'
import QAReport from '../components/quality/QAReport.vue'
import QAReportDetail from '../components/quality/QAReportDetail.vue'
import QualityCategory from '../components/quality/QualityCategory.vue'
import ProTimeLineGrap from '../components/timeline/ProTimeLineGrap.vue'
Vue.use(VueRouter)

// import VueCookies from 'vue-cookies'
// Vue.use(VueCookies);
// Vue.http.interceptors.push((request, next) => {
//   // 请求发送前的处理逻辑
//   const tokenStr = window.sessionStorage.getItem('token')
//   request.headers.set('Authorization', "token " + tokenStr)
//   next((response) => {
//     // 请求发送后的处理逻辑
//     // 根据请求的状态，response参数会返回给successCallback或errorCallback
//     return response
//   })
// })

const router = new VueRouter({
  // token = window.sessionStorage.getItem('token')
  routes: [
    { path: '/qaReportDetail', component: QAReportDetail },
    { path: '/publicTest', component: PublicTest },
    { path: '/', redirect: '/login' },
    // { path: '/test1', component: Test1 },
    // { path: '/test2', component: Test2 },
    { path: '/login', component: Login },
    {
      path: '/home',
      component: Home,
      redirect: '/welcome',
      children: [{ path: '/welcome', component: Welcome },
        { path: '/schedule', name: 'scheduleLink', component: Schedule },
        { path: '/delivery', component: Delivery },
        { path: '/moq', component: Moq },
        { path: '/readygoods', component: Readygoods },
        { path: '/rfqForwarder', component: RfqForwarder },
        { path: '/rglFileManage', component: RglFileManage },
        { path: '/rglFile', component: RglFile },
        { path: '/project', component: Project },
        { path: '/prospectProject', component: ProspectProject },
        { path: '/timeline', name: 'timelineLink', component: Timeline },
        { path: '/prospectTimeline', name: 'prospectTimelineLink', component: ProspectTimeline },
        { path: '/initQuote', component: InitQuotation },
        { path: '/pdr', name: 'pdrLink', component: Pdr },
        { path: '/forwarderschedule', component: ForwarderSchedule },
        { path: '/forwarderschedule4IPIT', component: ForwarderSchedule4IPIT },
        { path: '/yach1Schedule', component: Yach1Schedule },
        { path: '/inputSchedule', component: InputSchedule },
        { path: '/exportSchedule', component: ExportSchedule },
        { path: '/forwarderQtySchedule', component: ForwarderQtySchedule },
        { path: '/CRProject', component: CRProject },
        { path: '/CRTask', name: 'CRTaskLink', component: CRTask },
        { path: '/prospectCRProject', component: ProspectCRProject },
        { path: '/prospectCRTask', name: 'ProspectCRTaskLink', component: ProspectCRTask },
        { path: '/yach', component: Yach },
        { path: '/yach4Customer', component: Yach4Customer },
        { path: '/yachHistory', component: YachHistory },
        { path: '/yachUpdatesHistory', component: YachUpdatesHistory },
        { path: '/yach1CBMSchedule', component: Yach1CBMSchedule },
        { path: '/yachPOSchedule', component: YachPOSchedule },
        { path: '/brand', component: Brand },
        { path: '/customer', component: Customer },
        { path: '/customerContact', component: CustomerContact },
        { path: '/userManagement', component: UserManagement },
        { path: '/qcReport', component: QCReport },
        { path: '/qcSchedule', component: QCSchedule },
        { path: '/supplier', component: Supplier },
        { path: '/supplierQC', component: SupplierQC },
        { path: '/systemRole', component: SystemRole },
        { path: '/followUp', component: FollowUp },
        { path: '/factory', component: Factory },
        { path: '/machine', component: Machine },
        { path: '/outputCalendar', component: OutputCalendar },
        { path: '/qaRequest', component: QARequest },
        { path: '/qaTestRequest', component: QATestRequest },
        { path: '/qaReport', component: QAReport },
        { path: '/qualityCategory', component: QualityCategory },
        { path: '/proTimeLineGrap', component: ProTimeLineGrap },
        { path: '/output', component: Output },
        { path: '/subItem', component: SubItem }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.path === '/publicTest') return next()
  if (to.path === '/qaReportDetail') return next()
  if (to.path === '/login') return next()
  const tokenStr = window.sessionStorage.getItem('token')
  // alert('next===' + next)
  // console.log(tokenStr)
  if (!tokenStr) return next('/login')
  next()
})

export default router
